<template>
  <div class="d-flex flex-column mt-6">
    <rir-input
      class="mb-6"
      label="Название происшествия"
      v-model="eventData.name"
      :readonly="isRead"
      />
    <event-field-type
      class="mb-6"
      v-for="(field, index) in eventData.children"
      :key="field.id || index"
      :field="field"
      :is-read="isRead"
      />

    <rir-button
      @click="changeEdit"
      :loading="isSave"
      v-if="isRead"
    >
      Редактировать
    </rir-button>
    <template v-else>
      <rir-button
          :loading="isSave"
          class="mb-4"
          @click="saveEvent"
      >
        Сохранить
      </rir-button>
      <rir-button
          @click="deleteEvent"
          color="error"
      >
        Удалить
      </rir-button>
    </template>
  </div>
</template>

<script>
import EventFieldType from "@/components/kpiField/EventFieldType";
import {KpiApi} from "@/api/KpiApi";
import {DateFormatted} from "@/plugins/DateFormatted";
export default {
  name: 'event-field-constructor',
  components: {EventFieldType},
  mounted () {
    if (!this.event.id) {
      this.isRead = false
    }
  },
  data: (vm) => ({
    isSave: false,
    isRead: true,
    eventData: vm.event
  }),
  props: {
    event: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  methods: {
    async changeEdit () {
      const { data } = await KpiApi.changeMark(this.eventData.id, this.isRead ? 'PICK' : 'RELEASE')
      if (data.canEdit) {
        this.isRead = !this.isRead
      } else {
        this.$notification({
          icon: 'warning',
          type: 'error',
          text: `Данная запись уже редактируется пользователем ${data.editingBy} с ${(new DateFormatted(data.editStartTime)).ruFormat()}!`
        })
      }
    },
    async saveEvent () {
      this.isSave = true
      if (!this.eventData.name) {
        this.$notification({
          icon: 'warning',
          type: 'warning',
          text: 'Заполните название происшествия'
        })
      }
      const res = await KpiApi[this.eventData.id ? 'updateData' : 'createData'](this.eventData)
      if (res) {
        this.eventData.id = res.id
        await this.changeEdit()
      }
      this.isSave = false
    },
    async deleteEvent () {
      this.$emit('deleteEvent', {
        event: this.event,
        index: this.index,
      })
    }
  }
}
</script>
